import { Directive, HostListener } from '@angular/core';
import { Router } from '@angular/router';

@Directive({
	selector: '[pkWebContactUsWidget]',
})
export class ContactUsWidgetDirective {
	@HostListener('click') onClick() {
		this.navigateToContactUs();
	}

	constructor(private router: Router) {}

	public navigateToContactUs(): void {
		this.router.navigate(['/company/contact-us']);
	}
}
